import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import { T } from "../shared/typography.styles"
import Img from "gatsby-image"

/* 
@media(min-width: ${Breakpoints.md}){}
@media(min-width: ${Breakpoints.lg}){} 
*/

export const SectionContainer = styled.div`
  padding: 64px 0;

  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding-top: 64px;
  }
`

export const CardsFlexContainer = styled.div`
  grid-column: 2 / -2;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.lg}) {
    display: flex;
  }
`

export const CardsSliderContainer = styled.div`
  overflow: hidden;
  padding-top: 48px;
  grid-column: 1 / -1;
`

export const TestimonialCardWrapper = styled.figure`
  display: flex;
  flex-direction: column;
  @media (min-width: ${Breakpoints.md}) {
    flex-direction: row;
    margin-top: 32px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin: 0 16px;
    flex-direction: column;
    flex: 1 0 calc(33% - 32px);
  }
`
export const TestimonialContentWrapper = styled.div`
  padding: 24px 16px;
  text-align: center;
  @media (min-width: ${Breakpoints.md}) {
    padding: 0 32px;
    text-align: left;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 32px 0;
    text-align: center;
  }
`

export const TestimonialImage = styled(Img)`
  flex: 1 0 33%;

  @media (min-width: ${Breakpoints.lg}) {
    flex: unset;
    width: 100%;
    min-height: 270px;
    max-height: 325px;
  }
`

export const TestimonialName = styled.h4`
  ${T.md.h3.bold}
  color: var(--body-text-grey);
`
export const TestimonialTitle = styled.figcaption`
  ${T.md.body.regular}
  color: var(--burnt-orange);
  margin-top: 8px;
  @media (min-width: ${Breakpoints.lg}) {
    @media (max-width: 1170px) {
      min-height: 54px;
    }
  }
`

export const TestimonialText = styled.p`
  ${T.md.body.regular}
  color: var(--body-text-grey);
  margin-top: 16px;
`
